import React from 'react';
import axios from 'axios';
import { Button, Form, Segment, Input, Select } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class SemesterInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            optionalCoursesECTSMin: '',
            optionalCoursesECTSMax: '',
            optionalCoursesNumberMin: '',
            optionalCoursesNumberMax: '',
            studyProgramSemesterId: '',

            optionalCoursesECTSMinErr: false,
            optionalCoursesECTSMaxErr: false,
            optionalCoursesNumberMinErr: false,
            optionalCoursesNumberMaxErr: false,
            semesterErr: false
        };
        this.saveSemesterInfo = this.saveSemesterInfo.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    saveSemesterInfo(
        optionalCoursesECTSMin,
        optionalCoursesECTSMax,
        optionalCoursesNumberMin,
        optionalCoursesNumberMax,
        studyProgramSemesterId
    ) {
        let semesterObj = {
            optionalCoursesECTSMin,
            optionalCoursesECTSMax,
            optionalCoursesNumberMin,
            optionalCoursesNumberMax,
            studyProgramSemesterId,
            studyProgramId: this.props.id
        };

        if (!optionalCoursesECTSMin || !optionalCoursesECTSMax || !optionalCoursesNumberMin || !optionalCoursesNumberMax || !studyProgramSemesterId) {
            toast('Niste unijeli sva obavezna polja!');
            if (!optionalCoursesECTSMin) { this.setState({ optionalCoursesECTSMinErr: true }); } else { this.setState({ optionalCoursesECTSMinErr: false }); }
            if (!optionalCoursesECTSMax) { this.setState({ optionalCoursesECTSMaxErr: true }); } else { this.setState({ optionalCoursesECTSMaxErr: false }); }
            if (!optionalCoursesNumberMin) { this.setState({ optionalCoursesNumberMinErr: true }); } else { this.setState({ optionalCoursesNumberMinErr: false }); }
            if (!optionalCoursesNumberMax) { this.setState({ optionalCoursesNumberMaxErr: true }); } else { this.setState({ optionalCoursesNumberMaxErr: false }); }
            if (!studyProgramSemesterId) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
        } else if (parseInt(optionalCoursesECTSMin, 10) > parseInt(optionalCoursesECTSMax,10)) {
            toast('Maksimalna vrijednost mora biti veća od minimalne vrijendosti!');
            this.setState({
                optionalCoursesECTSMinErr: true,
                optionalCoursesECTSMaxErr: true
            });
        } else if (parseInt(optionalCoursesNumberMin,10) > parseInt(optionalCoursesNumberMax,10)) {
          toast('Maksimalna vrijednost mora biti veća od minimalne vrijendosti!');
            this.setState({
                optionalCoursesNumberMinErr: true,
                optionalCoursesNumberMaxErr: true
            });
        } else {
            axios.post('study-programs/add-semester', { ...semesterObj })
                .then(res => {
                    toast('Uspješno ste dodali novi semestar na implementaciju studijskog programa.');
                    this.props.getSemesters();
                })
                .catch(err => {
                    toast('Došlo je do greške! Dodavanje semestra nije uspjelo.');
                });
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <Segment.Group raised>
                <Segment><h3>Dodavanje novog semestra</h3></Segment>
                <Segment clearing>
                    <Form noValidate>
                        <Form.Group widths="equal">
                            <Form.Field
                                required
                                error={this.state.semesterErr}
                                control={Select}
                                clearable
                                options={this.props.lookupSemesters}
                                label="Broj semestra"
                                value={this.state.studyProgramSemesterId}
                                onChange={this.handleInputChange}
                                name="studyProgramSemesterId"
                                placeholder="Odaberite broj semestra"
                            />
                            <Form.Field />
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Field
                                required
                                error={this.state.optionalCoursesECTSMinErr}
                                control={Input}
                                label="Minimalan broj ECTS bodova za izborne predmete"
                                type="number"
                                min="0"
                                value={this.state.optionalCoursesECTSMin}
                                onChange={(e) => this.setState({ optionalCoursesECTSMin: e.target.value })}
                                name="optionalCoursesECTSMin"
                                placeholder="Unesite minimalan broj ECTS bodova"
                            />
                            <Form.Field
                                required
                                error={this.state.optionalCoursesECTSMaxErr}
                                control={Input}
                                label="Maksimalan broj ECTS bodova za izborne predmete"
                                type="number"
                                min="0"
                                value={this.state.optionalCoursesECTSMax}
                                onChange={(e) => this.setState({ optionalCoursesECTSMax: e.target.value })}
                                name="optionalCoursesECTSMax"
                                placeholder="Unesite maksimalan broj ECTS bodova"
                            />
                        </Form.Group>
                        <Form.Group widths="equal">

                            <Form.Field
                                required
                                error={this.state.optionalCoursesNumberMinErr}
                                control={Input}
                                label="Minimalan broj izbornih predmeta"
                                type="number"
                                min="0"
                                value={this.state.optionalCoursesNumberMin}
                                onChange={(e) => this.setState({ optionalCoursesNumberMin: e.target.value })}
                                name="optionalCoursesNumberMin"
                                placeholder="Unesite minimalan broj izbornih predmeta"
                            />
                            <Form.Field
                                required
                                error={this.state.optionalCoursesNumberMaxErr}
                                control={Input}
                                label="Maksimalan broj izbornih predmeta"
                                type="number"
                                min="0"
                                value={this.state.optionalCoursesNumberMax}
                                onChange={(e) => this.setState({ optionalCoursesNumberMax: e.target.value })}
                                name="optionalCoursesNumberMax"
                                placeholder="Unesite maksimalan broj izbornih predmeta"
                            />
                        </Form.Group>

                        <Button
                            color="blue"
                            onClick={() => this.saveSemesterInfo(
                                this.state.optionalCoursesECTSMin,
                                this.state.optionalCoursesECTSMax,
                                this.state.optionalCoursesNumberMin,
                                this.state.optionalCoursesNumberMax,
                                this.state.studyProgramSemesterId
                            )}

                        >  Sačuvaj
                        </Button>
                        <Button
                            color="blue"
                            basic="true"
                            onClick={this.props.closeAddSemesterMode}
                        >  Odustani
                        </Button>
                    </Form>
                    <ToastContainer hideProgressBar />
                </Segment>
            </Segment.Group>
        );
    }
}

export default SemesterInfo;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/AddSemesterInfo.js